/* eslint-disable arrow-body-style */
import { Modal } from '@mui/material';
import { StyledModalBox } from '../styles';
import { Category } from 'src/@types/Category';
import CategoryNewEditForm from 'src/sections/@dashboard/category/categoryNewEditForm';

export const CategoryModal = ({
  open,
  handleClose,
  isEdit,
  currentCategory,
}: {
  open: boolean;
  handleClose(): void;
  isEdit: boolean;
  currentCategory: Category | undefined;
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledModalBox>
        <CategoryNewEditForm
          handleClose={handleClose}
          isEdit={isEdit}
          currentCategory={currentCategory}
        />
      </StyledModalBox>
    </Modal>
  );
};
